import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import {
  CasRHFNumberField,
  CasRHFPercentField,
  CasRHFSwitch,
  CasStackRow,
} from 'src/compass/shared/components';

interface IProps {
  asofReadonly: boolean;
};

const isEmpty = (value: any) => value == null || value === '';

export default function SourceAdjustAfterFields({ asofReadonly }: IProps) {
  const triggerFields = ['asOf.adjustAfterYears', 'asOf.adjustAfterYearsByPercent'];

  const { control, trigger, getValues, setValue } = useFormContext();

  // On load the switch is on when either field already holds a value.
  const adjust = useWatch({ control, name: 'asOf.adjust' });
  const [loadedYears, loadedPercent] = getValues(triggerFields);
  const showAdjust = adjust ?? (!isEmpty(loadedYears) || !isEmpty(loadedPercent));

  useEffect(() => {
    setValue('asOf.adjust', showAdjust);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [adjustAfterYears, adjustAfterYearsByPercent] = useWatch({
    control,
    name: triggerFields,
  });

  useEffect(() => {
    if (adjustAfterYears !== undefined && adjustAfterYearsByPercent !== undefined)
      trigger(triggerFields);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adjustAfterYears, adjustAfterYearsByPercent, trigger]);

  const handleToggle = (_: { target: { value: boolean } }, checked: boolean) => {
    if (!checked) {
      setValue('asOf.adjustAfterYears', null);
      setValue('asOf.adjustAfterYearsByPercent', null);
    }
  };

  return (
    <CasStackRow gapSize="none">
      <CasRHFSwitch
        name="asOf.adjust"
        label="Adjust?"
        disabled={asofReadonly}
        onChange={handleToggle}
      />
      {showAdjust && (
        <>
          <CasRHFNumberField
            name="asOf.adjustAfterYears"
            label="After Years"
            disabled={asofReadonly}
          />
          <CasRHFPercentField
            name="asOf.adjustAfterYearsByPercent"
            label="Adjust by"
            disabled={asofReadonly}
          />
        </>
      )}
    </CasStackRow>
  );
}
